export const environment = {
  production: true,
  apiUrl: "https://api.kwmembers.org/api/",
  apiUrlArbitrators: "https://sharedapi.kwaaa-pac.org/",
  webUrl: "https://kwaaa-pac.org/",
  MainWebsite:'https://kwaaa.org/',
  classification_link: "https://kwaaaarb.asregyptgroup.com/",
  captchaSiteKey: "",
  captchaSecretKey: "",
  secret_key: "44@KSE2021Job@ME",
  mainLogo_arabic: "assets/img/logos/arabic-logo.jpeg",
  mainLogo_english: "assets/img/logos/english-logo.jpeg",
  mainLogo_arabic_white: "assets/img/logos/Logo.png",
  mainLogo_english_white: "assets/img/logos/logo.png",
  small_logo: "assets/img/logos/small_orginal_logo.png",
  mainLogo: "assets/img/logos/Logo.png",
  headerLogo: "assets/img/logos/KSELogo.png",
  secondaryLogo: "assets/img/logos/KSELogo.png",
  favicon: "assets/img/favicon.ico",
  scanFileUrl: "https://scan.kwaaa.org/api/FileScanner",
  scanFilePassword: "PEtER@W@Geeh.F@YeLCKann2r",
  supportPhone: "",
  socketUrl: "",
  supportEmail: "",
  currency: "SR",
  minAge: 18,
  idle_time_in_seconds: 1800,
  time_before_logout_in_seconds: 30,
  encryptedResponse: true,
};
